import type { Maybe } from '@/types/globals';

export interface ScannerTypes {
	element: Maybe<string>;
	evx: Maybe<string>;
	ng?: Maybe<string>;
	ngPro?: Maybe<string>;
}

export enum ScannerVersionPrefixByType {
	element = '1',
	evx = '2',
	ng = '3',
	ngPro = '4'
}

export interface ScannerTypesByVersioningType {
	clientVersion: ScannerTypes;
	packageVersion: ScannerTypes;
	anyVersionFrom?: string;
}
